module.exports = __webpack_public_path__ + "static/assets/4ef11a2e8972c53345084099dc5b3955.svg";